/**
 * Approval insights types — shared between L3 memory clients and ApprovalInsightsBadge.
 */

export interface ApprovalStats {
  total_similar: number;
  approved_count: number;
  rejected_count: number;
  approval_rate: number;
  approval_rate_display: string;
  avg_decision_time_seconds: number;
  common_approvers: string[];
  common_reasons: string[];
  most_recent_days_ago: number;
  confidence: 'low' | 'medium' | 'high';
  has_history: boolean;
}

export interface ApprovalInsightsResult {
  has_insights: boolean;
  stats: ApprovalStats;
  recommendation: 'approve' | 'reject' | 'review';
  recommendation_reason: string;
  precedent_summary: string;
  badge_color: 'gray' | 'green' | 'yellow' | 'orange' | 'red';
  badge_text: string;
}

const EMPTY_STATS: ApprovalStats = {
  total_similar: 0,
  approved_count: 0,
  rejected_count: 0,
  approval_rate: 0,
  approval_rate_display: '0%',
  avg_decision_time_seconds: 0,
  common_approvers: [],
  common_reasons: [],
  most_recent_days_ago: 0,
  confidence: 'low',
  has_history: false,
};

export const EMPTY_INSIGHTS: ApprovalInsightsResult = {
  has_insights: false,
  stats: EMPTY_STATS,
  recommendation: 'review',
  recommendation_reason: '',
  precedent_summary: '',
  badge_color: 'gray',
  badge_text: 'No history',
};

export type FetchApprovalInsights = (
  taskTitle: string,
  resourceType?: string,
  actionType?: string,
) => Promise<ApprovalInsightsResult>;
